import { useEffect, useState } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import moment from 'moment';
import { get } from 'lodash';

import { getCurrentSendedLanding, getCurrentSendedTakeOff, getTOCPoint } from '../../../selectors/sended-data';
import { TIMEOUT_IF_NO_TOC_POINT } from '../../../service/constants';

const getTimeMS = ({ eto, ato, takeOffTime, landingTime }) => {
    const nowUTC = moment.utc();
    const etoUTC = moment.utc(eto);

    if (!eto && !ato) {
        if (!takeOffTime || landingTime) {
            return -1;
        }
        const dateIfNoTocPointUTC = moment.utc(takeOffTime).add(TIMEOUT_IF_NO_TOC_POINT, 'milliseconds');
        const msIfNoTocPoint = dateIfNoTocPointUTC.diff(nowUTC, 'milliseconds');

        return msIfNoTocPoint > 0 ? msIfNoTocPoint : 0;
    }

    if (!ato && eto && etoUTC.isAfter(nowUTC)) {
        const msToEto = etoUTC.diff(nowUTC, 'milliseconds');

        return msToEto > 0 ? msToEto : 0;
    }

    return null;
};

export const useTimeout = () => {
    const { takeOffTime } = useSelector(getCurrentSendedTakeOff);
    const { landingTime } = useSelector(getCurrentSendedLanding);
    const { tocPoint } = useSelector(getTOCPoint, shallowEqual);
    const ato = get(tocPoint, 'ato', null);
    const eto = get(tocPoint, 'eto', null);

    const [timeMS, setTimeMS] = useState(getTimeMS({ eto, ato, takeOffTime, landingTime }));

    useEffect(() => {
        setTimeMS(getTimeMS({ eto, ato, takeOffTime, landingTime }));
    }, [eto, ato, takeOffTime, landingTime]);

    return timeMS;
};
